// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__35eh0","title":"Info_title__1jHft","selects":"Info_selects__8OtQ2","requiredAsterisk":"Info_requiredAsterisk__1ozhb"};